const midBusinessQuestions = [
  // Existing questions
  {
    question:
      "Who is the person to attend the Assessment Meeting for This Business. Include all Information",
    answer: "",
    placeholder:
      "The person to attend this meeting is Mr./Miss. last name, first name. To reach them call 1-123-123-1234, their email is...",
  },
  {
    question: "What are the key challenges you face as a Mid Level Business?",
    answer: "",
    placeholder:
      "As a Mid Level Business, we face challenges such as limited resources, competition, and building brand awareness.",
  },
  {
    question:
      "Do you have a business growth plan or expansion strategy in place?",
    answer: "",
    placeholder:
      "Yes, we have a growth plan that includes opening a new location and launching an online store to reach a wider audience.",
  },
  {
    question: "How do you currently channel sales for your business?",
    answer: "",
    placeholder:
      "We primarily channel sales through our e-commerce website and also partner with local retailers.",
  },
  {
    question:
      "What are your primary business objectives for the next year? (e.g., revenue growth, market expansion, profitability improvement)",
    answer:
      "Our main goal for the next year is to achieve a 20% growth in revenue through effective market expansion strategies.",
    placeholder: "We aim to expand our market and increase revenue by X%.",
  },
  // New questions tailored for mid-level business
  {
    question: "What are the current problems your business is facing?",
    answer: "",
    placeholder:
      "Our business is currently facing challenges in areas such as operational efficiency, workforce management, and customer retention.",
  },
  {
    question: "How do you plan to address these challenges?",
    answer: "",
    placeholder:
      "We are developing strategies to streamline operations, enhance employee training, and implement customer engagement initiatives.",
  },
  {
    question:
      "Are there any key partnerships or collaborations you are considering?",
    answer: "",
    placeholder:
      "We are exploring potential collaborations with industry peers to leverage each other's strengths and expand our market reach.",
  },
  {
    question:
      "What strategies do you have in place to drive sustainable growth?",
    answer: "",
    placeholder:
      "Our growth strategies include product diversification, targeted marketing campaigns, and optimizing our supply chain.",
  },
  // ... (add more questions tailored for a mid-level business)
  {
    question:
      "Is there anything else you'd like to share with us that you feel is important for the growth assessment?",
    answer: "",
    placeholder:
      "We value your insights. Please feel free to share any additional information that you think is relevant for our assessment.",
  },
];

export default midBusinessQuestions;
